export default __webpack_public_path__ + "static/media/FLORES.40cf1512.jpg";